import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";
import "tippy.js/themes/light.css";

export default class extends Controller {
  static values = {
    content: String,
    placement: { type: String, default: "auto" },
    theme: { type: String, default: "light" },
    allowHtml: { type: Boolean, default: true },
    trigger: { type: String, default: "mouseenter focus" },
  };

  connect() {
    try {
      this.tooltip = tippy(this.element, {
        content: this.contentValue,
        placement: this.placementValue,
        theme: this.themeValue,
        allowHTML: this.allowHtmlValue,
        trigger: this.triggerValue,
        onShow: (instance) => {
          const id = `tooltip-${instance.id}`;
          const { popper, reference } = instance;
          popper.id = id;
          reference.setAttribute("aria-describedby", id);
        },
        onHide: (instance) => {
          const { reference } = instance;
          reference.removeAttribute("aria-describedby");
        },
      });
    } catch (err) {
      console.warn("Failed to initialize tooltip:", err);
    }
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.destroy();
      this.tooltip = null;
    }
  }

  contentValueChanged(newValue) {
    if (this.tooltip) {
      this.tooltip.setContent(newValue);
    }
  }

  placementValueChanged(newValue) {
    if (this.tooltip) {
      this.tooltip.setProps({ placement: newValue });
    }
  }

  themeValueChanged(newValue) {
    if (this.tooltip) {
      this.tooltip.setProps({ theme: newValue });
    }
  }

  allowHtmlValueChanged(newValue) {
    if (this.tooltip) {
      this.tooltip.setProps({ allowHTML: newValue });
    }
  }

  triggerValueChanged(newValue) {
    if (this.tooltip) {
      this.tooltip.setProps({ trigger: newValue });
    }
  }
}
